/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PointDtoModel } from './point-dto.model';

export class AddressDTO extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;
  addressLabel: string | null = null;
  addressLine: string | null = null;
  streetName: string | null = null;
  streetNumber: string | null = null;
  city: string | null = null;
  cityCode: string | null = null;
  state: string | null = null;
  countyCode: string | null = null;
  country: string | null = null;
  details: string | null = null;
  postalCode: string | null = null;
  block: string | null = null;
  building: string | null = null;
  floor: string | null = null;
  apartment: string | null = null;

  deleted: boolean | null = null;
  pointDTO: PointDtoModel | null = null;


  addressTypeValue: string | null = null;
  visibilityType: string | null = null;
  isCompanyRequired: boolean | null = null;

  businessProfileUuid: string| null = null;
  originalAddressUuid: string| null = null;
  basedOnAddressTemplateUuid: string | null = null; // for DelAddress
}
